export default {
  common: {
    clearAll: 'مسح الكل',
    required: 'مطلوب',
    restart: 'إعادة التشغيل'
  },
  createUser: {
    acceptTermsAndConditions: 'قبول الشروط والأحكام',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟ %{pre}تحميل%{post}',
    checkEmail: 'في غضون ذلك، قم بتنزيل Metrica Play على جهاز الكمبيوتر الخاص بك',
    clubCompany: 'المنظمة/النادي',
    createdSuccessfully:
      'تم التسجيل بنجاح! تحقق من بريدك الإلكتروني المسجل للحصول على رابط التحقق. (تحقق من مجلد البريد العشوائي)',
    email: 'البريد الإلكتروني',
    invalidEmail: 'بريد إلكتروني غير متاح',
    job: 'الوظيفة/الدور',
    lastName: 'الاسم الأخير',
    name: 'الاسم الأول',
    noCustomOption: 'الخيار غير متاح',
    noMatches: 'لا توجد مطابقات، اكتب الخيار الخاص بك',
    password: 'كلمة المرور',
    passwordsDontMatch: 'كلمات المرور لا تتطابق',
    passwordInvalid: 'كلمة المرور لا تستوفي المتطلبات',
    passwordRequirements: {
      minLength: '%{count} أحرف على الأقل',
      uppercase: 'حرف كبير واحد',
      lowercase: 'حرف صغير واحد',
      number: 'رقم واحد (0-9)',
      maxLength: 'الحد الأقصى لعدد الأحرف: %{count}'
    },
    phone: 'الهاتف',
    phoneCode: 'الدولة',
    proceed: 'متابعة',
    repeatPassword: 'كرر كلمة المرور',
    searchPhoneCode: 'بحث…',
    seeTermsAndConditions: 'انظر الشروط والأحكام',
    signAgreement:
      'التسجيل في حساب Metrica Sports يعني أنك توافق على %{pre1}سياسة الخصوصية%{post1} و %{pre2}شروط الخدمة%{post2}',
    signUpHere: 'أنشئ حسابك للبدء.',
    sport: 'الرياضة',
    submitting: 'بدء...',
    title: 'ابدأ مع %{product}',
    userKeyField: 'هل لديك رمز ترويجي أو مفتاح مستخدم؟ املأ هذا الحقل'
  },
  error: {
    downloadPlay: 'إذا كان لديك حساب بالفعل، فقم بتنزيل أحدث إصدار من اللعبة وتسجيل الدخول.',
    emailTaken: 'تم أخذ هذا البريد الإلكتروني بالفعل',
    fieldTooLong: 'بعض الحقول طويلة جدًا. قم بتقصيرها وحاول مرة أخرى',
    oops: 'عفوا!',
    restart: 'يبدو أنك تحاول الدخول في شيء ما زلنا نطوره...',
    tryAgain: 'يرجى المحاولة مرة أخرى، إذا استمر هذا الخطأ، اتصل بفريق دعم Metrica Sports',
    userKey: 'المفتاح غير متاح. تحقق من مفتاحك وحاول مرة أخرى أو احذف الحقل لإكمال التسجيل'
  },
  invitation: {
    acceptButton: 'أقبل تغيير حسابي',
    accepting: 'قبول...',
    cancelButton: 'رفض',
    description1:
      'عندما يتم إضافتك إلى حساب Metrica Sports الجديد، سيتم نقل ملكية حسابك الحالي في Metrica Sports (والمعلومات المحتواة فيه) وتعيينها إلى مالك حساب Metrica Sports الجديد. جميع المعلومات والبيانات الموجودة حاليًا في حسابك في Metrica Sports، وأي معلومات أو بيانات يتم حفظها بعد قبولك لتغيير الحساب، ستكون مرئية ومتاحة لمالك حساب Metrica Sports الجديد وأي مدير(ين) على ذلك الحساب لاستخدامها ومشاركتها مع الآخرين وفقًا لتقدير مالك الحساب.',
    description2: 'بالنقر على "أوافق على تغيير حسابي"، فإنك توافق وتفوض ما يلي:',
    list1: 'سيتم نقل معلومات حسابك الحالي إلى حساب Metrica Sports الجديد.',
    list2:
      'كل معلومات الحساب المنقولة إلى حساب Metrica Sports الجديد الخاص بك من حسابك الحالي يمكن أن يديرها مالك الحساب الجديد و/أو المدير(ون).',
    list3:
      'في حساب Metrica Sports الجديد، سيكون دورك "عضو". لن تمتلك بعد الآن صلاحيات المالك أو الإداري من حسابك الحالي.',
    list4:
      'سترث إعدادات حساب Metrica Sports الجديد الخاص بك، والتي قد تكون أكثر أو أقل تقييدًا بناءً على دورك في الحساب، ويمكن إدارة إعداداتك من قبل مالك حساب Metrica Sports الجديد أو المدير(ين).',
    list5: 'قد يتم تعديل إعداداتك الحالية إذا كانت تتعارض مع إعدادات الحساب الجديد الذي تنضم إليه.',
    list6: 'قد لا توفر حسابك الجديد الوصول إلى جميع الميزات التي لديك في حسابك الحالي.',
    list7:
      'ليس من الممكن عكس عملية نقل حسابك بمجرد أن تبدأها، وستظل كل معلومات حسابك في حساب واحد.',
    list8:
      'بالنقر على "أوافق على تغيير حسابي"، ستصبح عضوًا مُدارًا في حساب %{pre1}%{email}%{post1} وتوافق على %{pre2}شروط الخدمة%{post2} و%{pre3}بيان الخصوصية%{post3} الخاص بـ Metrica Sports.',
    subtitle:
      'بقبولك هذه الدعوة الجديدة لحساب Metrica Sports، ستُضاف إلى حساب آخر من Metrica Sports.',
    title: 'دعوة'
  },
  jobs: {
    academyDirector: 'مدير الاكاديمية',
    assistantCoach: 'مساعد مدرب',
    dataAnalyst: 'محلل بيانات',
    doctor: 'طبيب',
    formerPlayer: 'لاعب سابق',
    goalkeeperCoach: 'مدرب حارس المرمى',
    headCoach: 'مدرب رئيسي',
    journalist: 'صحفي',
    other: 'أخرى',
    performance: 'اللياقة البدنية والأداء',
    player: 'لاعب',
    scout: 'كشاف',
    sportsDirector: 'مدير رياضي',
    student: 'طالب',
    videoAnalyst: 'محلل فيديو'
  },
  sports: {
    americanFootball: 'كرة القدم الأمريكية',
    baseball: 'البيسبول',
    basketball: 'كرة السلة',
    fieldHockey: 'هوكي الحقل',
    football: 'كرة القدم/كرة القدم',
    futsal: 'كرة الصالات',
    gaelicFootball: 'كرة القدم الغيلية',
    handball: 'كرة اليد',
    iceHockey: 'هوكي الجليد',
    lacrosse: 'اللاكروس',
    netball: 'كرة الشبكة',
    other: 'أخرى',
    padel: 'الباديل',
    rugby: 'الرجبي',
    tennis: 'كرة المضرب',
    volleyball: 'الكرة الطائرة'
  }
}
